import React from 'react';
import Modal from 'react-bootstrap/Modal';
import styles from './style.module.css';

interface Props {
  show: boolean;
  handleClose: () => void;
  imageUrl: string;
}

const ImagePreviewModal = ({ show, handleClose, imageUrl }: Props) => {
  return (
    <Modal size="xl" show={show} onHide={handleClose}>
      <Modal.Header className={styles.modHead}>
        <Modal.Title>Banner Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.faqContent}>
        <div className="mt-3">
          <div className="border rounded p-2">
            <img
              src={imageUrl}
              alt="Banner Preview"
              style={{
                width: '100%',
                height: 'auto',
                maxHeight: '70vh',
                objectFit: 'contain',
                borderRadius: '4px'
              }}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className={styles.modFoter}>
        <button type="button" className={styles.close} onClick={handleClose}>Close</button>
      </Modal.Footer>
    </Modal>
  );
};

export default ImagePreviewModal; 